<ion-header>
    <ion-toolbar>
      <ion-title>Restablecer contraseña</ion-title>
      <ion-buttons slot="end">
        <ion-button color="dark" (click)="closeModal()">
            <ion-icon name="close"></ion-icon>
          </ion-button>
    </ion-buttons>
    </ion-toolbar>
  </ion-header>

  
<ion-content >
  <div class="modalContainer reverseFlex">
    <p>Te enviaremos un correo electrónico y un SMS con el link para reestablecer la contraseña.</p>
    <app-form [questions]="restorePasswordQuestions" (submit)="sendRestorePasswordEmail()"></app-form>
    <button class="z-depth-2 smallButton" (click)="sendRestorePasswordEmail()">ENVIAR</button>
  </div>
    
</ion-content>
